import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';

const teamMembers = [
  {
    name: '李教授',
    role: '首席顾问',
    icon: 'ri-user-star-line',
    description: '性健康领域资深研究者，拥有20年临床经验与教学背景。致力于将科学研究的成果转化为大众可理解的健康知识。',
  },
  {
    name: '王博士',
    role: '内容总监',
    icon: 'ri-edit-line',
    description: '人体解剖学博士，专注于亲密关系与身体结构的关系研究。负责本网站所有内容的科学审核与质量控制。',
  },
  {
    name: '张老师',
    role: '资深编辑',
    icon: 'ri-book-open-line',
    description: '拥有丰富的科普写作经验，擅长将复杂的专业知识转化为通俗易懂的文字。现任本网站主笔编辑。',
  },
];

const milestones = [
  { year: '2024', title: '网站创立', desc: '传教士体位指南网站正式上线，致力于提供科学、专业的亲密关系知识科普。' },
  { year: '2025', title: '内容拓展', desc: '文章库扩展到50+篇深度内容，覆盖传教士体位的5大知识领域。' },
  { year: '2026', title: '品质升级', desc: '引入专家审核机制，全面升级内容质量与网站体验，服务更广泛的读者群体。' },
];

export default function About() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '传教士体位指南',
    url: 'https://www.chuanjiaoshi-tiwei.com/',
    description: '科学视角，专业指导，专注传教士体位知识科普与亲密关系质量提升。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@chuanjiaoshi-tiwei.com',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 传教士体位完全指南',
    description: '了解传教士体位指南团队、品牌故事与联系方式。科学视角，专业指导，专注亲密关系知识科普。',
    url: 'https://www.chuanjiaoshi-tiwei.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '传教士体位完全指南',
      url: 'https://www.chuanjiaoshi-tiwei.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <main className="min-h-screen bg-background-50 pt-16">
        {}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
          <div className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于我们
              </h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                我们是一个专注于亲密关系知识科普的专业团队。以科学视角和专业态度，为你提供关于传教士体位的全面、深入、准确的信息。
              </p>
            </div>
          </div>
        </div>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              我们的使命
            </h2>
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
              <p className="text-foreground-700 leading-relaxed mb-4">
                在信息时代，关于亲密关系的信息充斥着网络，但其中<strong>科学、准确、负责任的科普内容却少之又少</strong>。我们注意到，传教士体位作为人类最经典、使用最广泛的亲密姿势之一，却常常被简单化和误解。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                我们的使命是<strong>消除误解，传播科学</strong>。通过基于现代性医学、解剖学和心理学研究的专业内容，帮助每一位读者获得真正有价值的知识，从而提升亲密关系的质量。
              </p>
              <p className="text-foreground-700 leading-relaxed">
                我们相信，<strong>知识是提升生活质量最重要的工具</strong>。通过了解身体的运作原理、学习科学的技巧方法、理解情感沟通的重要性，每个人都能够建立更健康、更满意的亲密关系。
              </p>
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              团队介绍
            </h2>
            <div className="space-y-6">
              {teamMembers.map((member, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 flex flex-col sm:flex-row gap-5"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${member.icon} text-xl`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="font-heading text-base font-semibold text-foreground-900">
                        {member.name}
                      </h3>
                      <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                        {member.role}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {member.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-6 top-0 bottom-0 w-px bg-primary-200"></div>
              <div className="space-y-8">
                {milestones.map((milestone, index) => (
                  <div key={index} className="relative pl-16">
                    <div className="absolute left-4 top-1 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50"></div>
                    <div className="bg-background-100 rounded-lg border border-background-200/70 p-5">
                      <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-primary-100 text-primary-700 mb-2">
                        {milestone.year}
                      </span>
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                        {milestone.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {milestone.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {}
        <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">电子邮件</h3>
                <p className="text-xs text-foreground-500">
                  contact@chuanjiaoshi-tiwei.com
                </p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">工作时间</h3>
                <p className="text-xs text-foreground-500">
                  周一至周五 9:00-18:00
                </p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">反馈建议</h3>
                <p className="text-xs text-foreground-500">
                  欢迎提出宝贵意见
                </p>
              </div>
            </div>

            {}
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 text-center">
                读者反馈表
              </h3>
              <p className="text-sm text-foreground-500 text-center mb-6">
                如有任何问题、建议或合作意向，欢迎通过以下表单联系我们
              </p>
              <form
                className="space-y-4 max-w-md mx-auto"
                data-readdy-form=""
                id="about-contact-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget as HTMLFormElement;
                  const formData = new FormData(form);
                  const hpVal = (formData.get('mobile_alt') as string || '').trim();
                  if (hpVal) {
                    alert('感谢你的反馈！我们会尽快回复。');
                    form.reset();
                    return;
                  }
                  fetch('https://readdy.ai/api/form/d9q8rusnlsngrm4llti0', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  })
                    .then(async (res) => {
                      const text = await res.text();
                      if (res.ok) {
                        alert('感谢你的反馈！我们会尽快回复。');
                        form.reset();
                      } else {
                        alert('提交失败，请稍后再试。');
                      }
                    })
                    .catch(() => alert('网络错误，请稍后再试。'));
                }}
              >
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入你的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入你的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    主题
                  </label>
                  <select
                    id="contact-subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  >
                    <option value="">请选择主题</option>
                    <option value="content">内容建议</option>
                    <option value="cooperation">商务合作</option>
                    <option value="feedback">网站反馈</option>
                    <option value="other">其他</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入你的留言（500字以内）"
                  ></textarea>
                </div>

                {}
                <div style={{ position: 'absolute', left: '-9999px', opacity: 0 }} aria-hidden="true">
                  <label htmlFor="mobile_alt">Mobile</label>
                  <input
                    type="text"
                    id="mobile_alt"
                    name="mobile_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                  />
                </div>

                <button
                  type="submit"
                  className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  提交反馈
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}